import type { FilterFieldConfig } from 'components/common/MasterFilter';
import { DEFAULT_META_DATE_PRESET, META_DATE_PRESET_OPTIONS } from 'utils/metaDatePresets';

/**
 * Filter field keys exposed by the campaign control panel. Kept as a literal union so
 * sections/mappers can reference them type-safely without stringly-typed lookups.
 */
export const FILTER_KEYS = {
  datePreset: 'datePreset',
  metaStatus: 'metaStatus',
  campaignIds: 'campaignIds',
} as const;

export const campaignFilterFields: FilterFieldConfig[] = [
  {
    key: FILTER_KEYS.datePreset,
    kind: 'metaDatePreset',
    label: 'Período',
    placement: 'bar',
    options: META_DATE_PRESET_OPTIONS,
    defaultValue: DEFAULT_META_DATE_PRESET,
  },
  {
    key: FILTER_KEYS.campaignIds,
    kind: 'multiSelect',
    label: 'Campañas',
    placement: 'bar',
    // Options injected from index.tsx via dynamicOptions, derived from allRows.
    defaultValue: [],
  },
  {
    key: FILTER_KEYS.metaStatus,
    kind: 'singleSelect',
    label: 'Estado Meta',
    placement: 'modal',
    options: [
      { value: 'all', label: 'Todas' },
      { value: 'active', label: 'Activas' },
      { value: 'inactive', label: 'Pausadas' },
    ],
    // Default to active-only so the first load stays compact: a BU with dozens of
    // archived or paused campaigns shouldn't overwhelm the table on open. Users who
    // want the full set can clear the "Estado Meta: Activas" chip or flip it in the
    // advanced modal.
    defaultValue: 'active',
  },
];
